import gql from 'graphql-tag';

export const paymentDetail = gql`
  query getPaymentDetail($itemNumber: String) {
    studentPayment(filter: { itemNumber: $itemNumber }) {
      name
      status
      period
      paymentType {
        id
        desc
      }
      amount
      discountBenefit {
        available
        value
      }
      discountSoonPayment {
        available
        value
      }
      total
      recharge
      dueDate
      paymentDate
      billDate
    }
  }
`;
